import moment from 'moment';
import * as actions from './types';

const initialState = {
  timeBucketCategories: {
    data: [],
    isLoading: false,
    isError: false,
  },
  categoriesToBeRefreshed: [], // Array of category IDs that need to be refreshed, e.g. [categoryId_1, categoryId_2]
  totalHoursByDate: {},
  // totalHoursByDate: {
  //   categoryId_1: {
  //     '2025-07-01': 5,
  //   },
  //   categoryId_2: {
  //     '2025-07-02': 3,
  //   },
  // },
  calendarYearTotalHours: {},
  // calendarYearTotalHours: {
  //   timeBucketId_1: {
  //     hours: 120.5,
  //     isLoading: false,
  //     isError: false,
  //   },
  // },
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case actions.GET_TIME_BUCKET_CATEGORIES:
      return {
        ...state,
        timeBucketCategories: {
          ...state.timeBucketCategories,
          isLoading: true,
        },
      };
    case actions.GET_TIME_BUCKET_CATEGORIES_SUCCESS:
      return {
        ...state,
        timeBucketCategories: {
          ...state.timeBucketCategories,
          isLoading: false,
          data: action.payload.categories,
        },
      };
    case actions.GET_TIME_BUCKET_CATEGORIES_FAILURE:
      return {
        ...state,
        timeBucketCategories: {
          ...state.timeBucketCategories,
          isLoading: false,
          isError: true,
        },
      };
    case actions.GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY:
      return {
        ...state,
      };
    case actions.GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY_SUCCESS: {
      const weekdates = action.selectedDays.map((date) =>
        moment(date).format('YYYY-MM-DD')
      );
      const projectSums = Array(7).fill(0);

      action.payload.buckets.forEach((bucket) => {
        const filteredBucket = bucket.timeEntries.filter((x) => x);
        filteredBucket.forEach((entry) => {
          const entryDate = entry.entryDate;
          const dateIndex = weekdates.indexOf(entryDate);

          if (dateIndex !== -1) {
            projectSums[dateIndex] += entry.hours || 0;
          }
        });
      });

      return {
        ...state,
        totalHoursByDate: {
          ...state.totalHoursByDate,
          ['categoryId_' + action.categoryId]: {
            ...action.selectedDays.reduce((acc, date, index) => {
              acc[moment(date).format('YYYY-MM-DD')] = projectSums[index];
              return acc;
            }, {}),
          },
        },
      };
    }
    case actions.GET_TIME_BUCKET_ENTRIES_FOR_CATEGORY_FAILURE:
      return {
        ...state,
      };
    case actions.GET_TIME_BUCKET_CYT:
      return {
        ...state,
        calendarYearTotalHours: {
          ...state.calendarYearTotalHours,
          ['timeBucketId_' + action.timeBucketId]: {
            hours: state.calendarYearTotalHours['timeBucketId_' + action.timeBucketId]?.hours || 0,
            isLoading: true,
            isError: false,
          },
        },
      };
    case actions.GET_TIME_BUCKET_CYT_SUCCESS:
      return {
        ...state,
        calendarYearTotalHours: {
          ...state.calendarYearTotalHours,
          ['timeBucketId_' + action.timeBucketId]: {
            hours: action.payload.calendarYearTotalHours,
            isLoading: false,
            isError: false,
          },
        },
      };
    case actions.GET_TIME_BUCKET_CYT_FAILURE:
      return {
        ...state,
        calendarYearTotalHours: {
          ...state.calendarYearTotalHours,
          ['timeBucketId_' + action.timeBucketId]: {
            hours: state.calendarYearTotalHours['timeBucketId_' + action.timeBucketId]?.hours || 0,
            isLoading: false,
            isError: true,
          },
        },
      };
    case actions.UPDATE_CATEGORIES_TO_BE_REFRESHED:
      return {
        ...state,
        categoriesToBeRefreshed: [
          ...state.categoriesToBeRefreshed,
          ...action.payload,
        ],
      };
    case actions.REMOVE_FROM_CATEGORIES_TO_BE_REFRESHED:
      return {
        ...state,
        categoriesToBeRefreshed: state.categoriesToBeRefreshed.filter(
          (id) => !action.payload.includes(id)
        ),
      };
    default:
      return state;
  }
};
